import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { InfoBannerComponent } from './info-banner/info-banner.component';
import { SmsRegistrationService } from './service/sms.service';
import { SmsRegistrationAlertComponent } from './sms-registration-alert/sms-registration-alert.component';
import { SmsRegistrationCardComponent } from './sms-registration-card/sms-registration-card.component';
import { SmsRegistrationErrorBannerComponent } from './sms-registration-error-banner/sms-registration-error-banner.component';
import { BusinessCategoryToLabelPipe } from './sms-registration-form/pipes/business-category-to-label.pipe';
import { RegionToLabelPipe } from './sms-registration-form/pipes/region-to-label.pipe';
import { SmsRegistrationFormComponent } from './sms-registration-form/sms-registration-form.component';
import { SmsRegistrationComponent } from './sms-registration/sms-registration.component';
import { TranslateModule } from '@ngx-translate/core';
import { SMSI18NModule } from './assets/i18n/sms-i18n.module';
import { ProgressTrackerComponent } from './progress-tracker/progress-tracker.component';

@NgModule({
  declarations: [
    SmsRegistrationFormComponent,
    SmsRegistrationComponent,
    SmsRegistrationAlertComponent,
    SmsRegistrationErrorBannerComponent,
    SmsRegistrationCardComponent,
  ],
  exports: [SmsRegistrationComponent, SmsRegistrationAlertComponent, SmsRegistrationCardComponent],
  imports: [
    CommonModule,
    MatCardModule,
    GalaxyFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    ReactiveFormsModule,
    BusinessCategoryToLabelPipe,
    RegionToLabelPipe,
    MatIconModule,
    InfoBannerComponent,
    GalaxyAlertModule,
    MatChipsModule,
    GalaxyBadgeModule,
    GalaxyPopoverModule,
    CdkOverlayOrigin,
    TranslateModule,
    SMSI18NModule,
    ProgressTrackerComponent,
  ],
  providers: [SmsRegistrationService],
})
export class SmsModule {}
